import { AuthenticatedService } from "../abstract/base.service";

class ConfigsService extends AuthenticatedService {
  Load(url: string, query?: string | null | undefined): Promise<any[]> {
    return this.Get<any[]>(
      `${this.baseUrl}${url.indexOf("?") > 0 ? url + "&" : url + "?"}${query ??
        ""}`
    );
  }

  Create(url: string, item: any): Promise<any> {
    return this.Post<any>(`${this.baseUrl}${url}`, item);
  }

  Edit(url: string, id: number, item: any): Promise<any> {
    return this.Put<any>(`${this.baseUrl}${url}/${id}`, item);
  }

  Remove(url: string, id: number): Promise<any> {
    return this.Delete<any>(`${this.baseUrl}${url}/${id}`);
  }

  Redorder(url: string, ids: number[]): Promise<any> {
    return this.Put<any>(`${this.baseUrl}${url}/reorder`, ids);
  }
}

export default ConfigsService;
